export enum ObservationLocationTypeEnum {
    SunbeltDepot = 'SUNBELTDEPOT',
    CustomerSite = 'CUSTOMERSITE',
    Other = 'OTHER'
}